// extracted by mini-css-extract-plugin
module.exports = {"wrapperTopSpacing":"_2lbb5_i","fixStyleGuideColumns":"EzWN_sJ","lockDetailsWidth":"_3394qVu","flexGrow":"nR_IJyi","lockSideColumnWidth":"_2IyR1MZ","coverImage":"sr4teXI","coverImagePlaceholder":"_1FJx0II"};
    if(module.hot) {
      // 1545369454063
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  